import React, {useState} from "react";
import ImageLightbox from "../common/ImageLightbox";

const GUIDE_IMAGE = "/images/set-stars-rating-guide.png";

const SetStarsRatingGuide = ({className = ""}) => {
    const [fullImage, setFullImage] = useState(null);

    return (
        <div className={`border rounded bg-light p-2 mt-2 ${className}`}>
            <div className="d-flex flex-column flex-md-row gap-3 align-items-start">
                <button
                    type="button"
                    className="border-0 bg-transparent p-0 flex-shrink-0 d-flex flex-column align-items-center"
                    title="Click to view full size"
                    onClick={() => setFullImage(GUIDE_IMAGE)}
                    style={{cursor: "zoom-in", width: "130px"}}
                >
                    <img
                        src={GUIDE_IMAGE}
                        alt="Amazon star rating confirmation example"
                        className="img-fluid rounded border bg-white"
                        style={{
                            width: "95px",
                            height: "auto",
                            display: "block",
                        }}
                    />
                    <div className="small text-muted text-center mt-1 w-100">Click to view full size</div>
                </button>
                <div className="text-muted">
                    <div className="fw-semibold text-success mb-1">How to finish the star rating correctly:</div>
                    <div>
                        After selecting the stars, Amazon may show an <strong>Add a review</strong> form.
                        Do <strong>not</strong> write review text for this assignment and do <strong>not</strong> click <strong>Submit</strong>.
                    </div>
                    <div className="mt-1">
                        Click <strong>No, Thank You</strong>. The star rating is already posted when Amazon shows
                        <strong> Your rating was posted on Amazon</strong>.
                    </div>
                    <div className="mt-1">
                        Use that screen as proof: the completed stars and reviewer/account name should be visible.
                    </div>
                </div>
            </div>
            <ImageLightbox
                src={fullImage}
                alt="Amazon star rating instructions"
                onClose={() => setFullImage(null)}
            />
        </div>
    );
};

export default SetStarsRatingGuide;
